import {Iterable, List} from "immutable";

export interface TypedList<T extends TypedList<T>> extends List<T> {
  set(index: number, value: T): List<T>;
  delete(index: number): List<T>;
  remove(index: number): List<T>;
  insert(index: number, value: T): List<T>;
  clear(): List<T>;
  push(...values: T[]): List<T>;
  pop(): List<T>;
  unshift(...values: T[]): List<T>;
  shift(): List<T>;
  update(updater: (value: List<T>) => List<T>): List<T>;
  update(index: number, updater: (value: T) => T): List<T>;
  update(index: number, notSetValue: T, updater: (value: T) => T): List<T>;
  merge(...iterables: Iterable.Indexed<T>[]): List<T>;
  merge(...iterables: Array<T>[]): List<T>;
  mergeWith(merger: (previous?: T, next?: T, key?: number) => T,
            ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeWith(merger: (previous?: T, next?: T, key?: number) => T,
            ...iterables: Array<T>[]): List<T>;
  mergeDeep(...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeDeep(...iterables: Array<T>[]): List<T>;
  mergeDeepWith(merger: (previous?: T, next?: T, key?: number) => T,
                ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeDeepWith(merger: (previous?: T, next?: T, key?: number) => T,
                ...iterables: Array<T>[]): List<T>;
  setSize(size: number): List<T>;
  setIn(keyPath: Array<any>, value: any): List<T>;
  setIn(keyPath: Iterable<any, any>, value: any): List<T>;
  deleteIn(keyPath: Array<any>): List<T>;
  deleteIn(keyPath: Iterable<any, any>): List<T>;
  removeIn(keyPath: Array<any>): List<T>;
  removeIn(keyPath: Iterable<any, any>): List<T>;
  updateIn(keyPath: Array<any>,
           updater: (value: any) => any): List<T>;
  updateIn(keyPath: Array<any>,
           notSetValue: any,
           updater: (value: any) => any): List<T>;
  updateIn(keyPath: Iterable<any, any>,
           updater: (value: any) => any): List<T>;
  updateIn(keyPath: Iterable<any, any>,
           notSetValue: any,
           updater: (value: any) => any): List<T>;
  mergeIn(keyPath: Iterable<any, any>,
          ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeIn(keyPath: Array<any>,
          ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeIn(keyPath: Array<any>,
          ...iterables: Array<T>[]): List<T>;
  mergeDeepIn(keyPath: Iterable<any, any>,
              ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeDeepIn(keyPath: Array<any>,
              ...iterables: Iterable.Indexed<T>[]): List<T>;
  mergeDeepIn(keyPath: Array<any>,
              ...iterables: Array<T>[]): List<T>;
  withMutations(mutator: (mutable: List<T>) => any): List<T>;
  asMutable(): List<T>;
  asImmutable(): List<T>;
}


export function makeTypedFactoryList<E, T extends TypedList<T> & E>(obj?: E, name?: string): (val?: E[]) => TypedList<T> {
  const immutableList = List<E>();
  return function TypedFactory(val: E[] = []): TypedList<T> {
    return val ? immutableList.concat(val) as TypedList<T> : immutableList as TypedList<T>;
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/typed-list.ts